import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

//import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

import {environment} from '../../environments/environment';

@Component({
  selector: 'app-forecast-at-completion-cost-hour',
  templateUrl: './forecast-at-completion-cost-hour.component.html',
  styleUrls: ['./forecast-at-completion-cost-hour.component.css']
})
export class ForecastAtCompletionCostHourComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    //figure out which columns should be disabled/enabled
    //report config -> FAC By NonRecurring/Recurring Toggle
    if (this.report.ReportConfiguration.data[3].Value !== true) {
      //disable FAC Non Recurrding/Recurring
      this.report.ForecastAtCompletionCostHourData.columns[2].readOnly = true;
    }
    //report config -> FAC By Standard Cat Toggle
    if (this.report.ReportConfiguration.data[4].Value !== true) {
      //disable FAC Standard and Detailed Cat
      this.report.ForecastAtCompletionCostHourData.columns[3].readOnly = true;
      this.report.ForecastAtCompletionCostHourData.columns[4].readOnly = true;
    } else {
      //report config -> Detailed Standard Cat Toggle
      if (this.report.ReportConfiguration.data[0].Value !== true) {
        //disable FAC Detailed Cat
        this.report.ForecastAtCompletionCostHourData.columns[4].readOnly = true;
      } else {
        //disable FAC Standard Cat
        this.report.ForecastAtCompletionCostHourData.columns[3].readOnly = true;
      }
    }
    
    //this is hacky, but need to jam in Order/Lot IDs.  
    let orderLotSource = [];
    for(let i=0; i < this.report.OrdersOrLots.data.length; i++) {
      orderLotSource.push(this.report.OrdersOrLots.data[i].ID);
    }
    for(let i=0; i < this.report.ForecastAtCompletionCostHourData.columns.length; i++) {
      if(this.report.ForecastAtCompletionCostHourData.columns[i].data === 'OrderOrLotID') {
        this.report.ForecastAtCompletionCostHourData.columns[i].source = orderLotSource;
        break;
      }
    }
    //and WBS Element ID
    let wbsSource = [];
    for(let i=0; i < this.report.WBS.data.length; i++) {
      wbsSource.push(this.report.WBS.data[i].ID);
    }
    for(let i=0; i < this.report.ForecastAtCompletionCostHourData.columns.length; i++) {
      if(this.report.ForecastAtCompletionCostHourData.columns[i].data === 'WBSElementID') {
        this.report.ForecastAtCompletionCostHourData.columns[i].source = wbsSource;
        break;
      }
    }
    this.columns = this.report.ForecastAtCompletionCostHourData.columns;
    this.data = this.report.ForecastAtCompletionCostHourData.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.report.ForecastAtCompletionCostHourData.columns[2].readOnly = false;
    this.report.ForecastAtCompletionCostHourData.columns[3].readOnly = false;
    this.report.ForecastAtCompletionCostHourData.columns[4].readOnly = false;
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.CLINS.data;
    const gridInstance = this.gridContext.getInstance('FACS');
    gridInstance.loadData(this.data);
  }

  addRow() {
    const gridInstance = this.gridContext.getInstance('FACS');
    gridInstance.alter('insert_row', gridInstance.countRows());
  }
}


// WEBPACK FOOTER //
// ./src/app/forecast-at-completion-cost-hour/forecast-at-completion-cost-hour.component.ts